import { useAction } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { reatomPossibleShortcutAtom } from '../../atoms/reatom-possible-shortcut'

import type { ShortcutId } from '../../shortcut-id'

export interface PossibleShortcutProps {
  shortcutId: ShortcutId
  children: React.ReactNode
}

export const PossibleShortcut = ({
  shortcutId,
  children,
}: PossibleShortcutProps) => {
  const setPossibleShortcut = useAction(reatomPossibleShortcutAtom)

  return (
    <Root
      onMouseEnter={() => setPossibleShortcut(shortcutId)}
      onMouseLeave={() => setPossibleShortcut(undefined)}
    >
      {children}
    </Root>
  )
}

const Root = styled.div`
  display: contents;
`
